/**
 * Chat entry points. The chooser keeps the bottom navigation, so its path must
 * not contain "/chat" — Layout and Footer hide the nav on any such path. The
 * host and Servy chats live under /chat and are shown without it.
 */
export const CHAT_OPTIONS_SEGMENT = "messages";

export const chatOptionsPath = (roomUuid) => `/${roomUuid}/${CHAT_OPTIONS_SEGMENT}`;
export const hostChatPath = (roomUuid) => `/${roomUuid}/chat`;
export const servyChatPath = (roomUuid) => `/${roomUuid}/chat/servy`;
